// removed by extract-text-webpack-plugin
module.exports = {"vpVideoCollectorContainer":"vpVideoCollectorContainer___3RxYB","vpHeader":"vpHeader___2Shv8","vpLabel":"vpLabel___1yEvl","vpDescription":"vpDescription___1vnfr","vpRequiredLabel":"vpRequiredLabel___15kA0","vpVideoPanel":"vpVideoPanel___7g8kI","vpProgressBar":"vpProgressBar___1P6jd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoCollector.module.less
// module id = 3810
// module chunks = 33